import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const DisconnectIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 14h8a1 1 0 0 1 0 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a1 1 0 1 1 0 2H3v12Zm8.707-9.707 3 3a1 1 0 0 1 0 1.414l-3 3a.998.998 0 0 1-1.645-.316 1 1 0 0 1 .231-1.098L11.586 9H6a1 1 0 0 1 0-2h5.586l-1.293-1.293a1 1 0 0 1 1.414-1.414Z", fill: "currentColor" })));
});
DisconnectIcon.displayName = 'DisconnectIcon';
export default DisconnectIcon;
